import { GENIUS_ROUTES, isGeniusRoute } from "./geniusRouteConstants";

/** Genius routes with real page content (not placeholder / coming soon). */
export const GENIUS_READY_ROUTES = Object.freeze([
  GENIUS_ROUTES.HOME,
  GENIUS_ROUTES.SCHOOL_REGISTER,
  GENIUS_ROUTES.SCHOOL_LOGIN,
  GENIUS_ROUTES.OLYMPIAD_MATH,
  GENIUS_ROUTES.OLYMPIAD_SCORE,
  GENIUS_ROUTES.OLYMPIAD_HOTS,
  GENIUS_ROUTES.CHAMPIONS,
  GENIUS_ROUTES.ABOUT,
  GENIUS_ROUTES.NOT_FOUND
]);

const normalizePath = (href) => {
  if (!href || typeof href !== "string") return "";
  const path = href.split("?")[0].split("#")[0];
  return path.startsWith("/") ? path : `/${path}`;
};

const isExternalHref = (href) =>
  /^(https?:|mailto:|tel:)/i.test(href);

/**
 * @param {string} pathname
 * @param {{ olympiads?: Array<{ route?: string; status?: string }> }} [options]
 */
export const isGeniusRouteReady = (pathname, options = {}) => {
  const path = normalizePath(pathname);
  if (!path || !isGeniusRoute(path)) return false;
  if (GENIUS_READY_ROUTES.includes(path)) return true;

  const olympiad = (options.olympiads ?? []).find((entry) => entry.route === path);
  if (olympiad) return olympiad.status === "live";

  return false;
};

/**
 * Resolve where an internal/external link should go.
 *
 * - Genius route + content ready → stay in Genius on that path
 * - Genius route + not ready → Genius not-found page
 * - Not a Genius route → Inmobius path (terms, privacy, page-not-found, etc.)
 * - External (http/mailto/tel) → open as-is
 *
 * @param {string} href
 * @param {{ olympiads?: Array<{ route?: string; status?: string }> }} [options]
 * @returns {{ type: "inactive" | "external" | "genius" | "inmobius"; href?: string }}
 */
export const resolveGeniusLinkTarget = (href, options = {}) => {
  if (!href || href === "#") return { type: "inactive" };
  if (isExternalHref(href)) return { type: "external", href };

  const path = normalizePath(href);

  if (isGeniusRoute(path)) {
    if (isGeniusRouteReady(path, options)) {
      return { type: "genius", href: path };
    }
    return { type: "genius", href: GENIUS_ROUTES.NOT_FOUND };
  }

  return { type: "inmobius", href: path };
};
